export enum ReviewStage {
  UnReviewed = 'un_reviewed',
  Pass = 'pass',
  Failed = 'failed',
  All = 'all',
}
